import { render, staticRenderFns } from "./vendorUpdate.vue?vue&type=template&id=4bea2e49"
import script from "./vendorUpdate.vue?vue&type=script&lang=js"
export * from "./vendorUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports